<template>
  <v-row>
    <v-col cols="6" :sm="showTime ? 3 : 6">
      <v-menu
        ref="dateMinOpen"
        v-model="dateMinOpen"
        :close-on-content-click="false"
        transition="scale-transition"
        min-width="290px"
        offset-y
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            :value="dateMin"
            label="Start Date"
            color="secondary"
            prepend-icon="mdi-calendar-outline"
            readonly
            v-on="on"
          />
        </template>
        <v-date-picker
          :value="dateMin"
          :max="dateMax"
          color="secondary"
          landscape
          scrollable
          @input="updateDateMin"
        >
          <v-spacer />
          <v-btn color="secondary" large @click="dateMinOpen = false">
            Cancel
          </v-btn>
        </v-date-picker>
      </v-menu>
    </v-col>
    <v-col v-if="showTime" cols="6" sm="3">
      <v-menu
        ref="timeMinOpen"
        v-model="timeMinOpen"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        max-width="290px"
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            :value="timeMin"
            label="Start Time"
            prepend-icon="mdi-clock-outline"
            readonly
            v-on="on"
          ></v-text-field>
        </template>
        <v-time-picker
          v-if="timeMinOpen"
          :value="timeMin"
          full-width
          ampm-in-title
          @input="updateTimeMin"
        ></v-time-picker>
        <v-btn class="full-width" v-if="timeMinOpen" @click="updateTimeMin(null)">Clear</v-btn>
      </v-menu>
    </v-col>
    <v-col cols="6" :sm="showTime ? 3 : 6">
      <v-menu
        ref="dateMaxOpen"
        v-model="dateMaxOpen"
        :close-on-content-click="false"
        transition="scale-transition"
        min-width="290px"
        offset-y
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            :value="dateMax"
            label="End Date"
            color="secondary"
            prepend-icon="mdi-calendar-outline"
            readonly
            v-on="on"
          />
        </template>
        <v-date-picker
          :value="dateMax"
          :min="dateMin"
          color="secondary"
          landscape
          scrollable
          @input="updateDateMax"
        >
          <v-spacer />
          <v-btn color="secondary" large @click="dateMaxOpen = false">
            Cancel
          </v-btn>
        </v-date-picker>
      </v-menu>
    </v-col>
    <v-col v-if="showTime" cols="6" sm="3">
      <v-menu
        ref="timeMaxOpen"
        v-model="timeMaxOpen"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        max-width="290px"
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            :value="timeMax"
            label="End Time"
            prepend-icon="mdi-clock-outline"
            readonly
            v-on="on"
          ></v-text-field>
        </template>
        <v-time-picker
          v-if="timeMaxOpen"
          :value="timeMax"
          full-width
          ampm-in-title
          @input="updateTimeMax"
        ></v-time-picker>
        <v-btn class="full-width" v-if="timeMaxOpen" @click="updateTimeMax(null)">Clear</v-btn>
      </v-menu>
    </v-col>
  </v-row>
</template>

<script>
import moment from 'moment-timezone';

import { dateFormat } from '@/utils/dates';

export default {
  props: {
    dateMin: {
      type: String,
      default: '',
    },
    dateMax: {
      type: String,
      default: '',
    },
    timeMin: {
      type: String,
      default: '',
    },
    timeMax: {
      type: String,
      default: '',
    },
    showTime: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dateMinOpen: false,
      dateMaxOpen: false,
      timeMinOpen: false,
      timeMaxOpen: false,
    };
  },
  watch: {
    dateMin: {
      handler(dateMin) {
        if (dateMin !== this.$route.query.dateMin && moment(dateMin, dateFormat).isValid()) {
          this.addParamsToUrl({ dateMin });
        }
      },
    },
    dateMax: {
      handler(dateMax) {
        if (moment(dateMax, dateFormat).isValid()) {
          this.addParamsToUrl({ dateMax });
        }
      },
    },
  },
  methods: {
    updateDateMin(value) {
      this.dateMinOpen = false;
      this.$emit('update:dateMin', value);
    },
    updateDateMax(value) {
      this.dateMaxOpen = false;
      this.$emit('update:dateMax', value);
    },
    updateTimeMin(value) {
      this.timeMinOpen = false;
      this.$emit('update:timeMin', value);
    },
    updateTimeMax(value) {
      this.timeMaxOpen = false;
      this.$emit('update:timeMax', value);
    },
    addParamsToUrl(params) {
      // Vue is being dumb and doesn't want this line of code to work
      // This produces a "duplicate navigation" error and doesn't actually update the query params
      // this.$router.push({ query: Object.assign(this.$route.query, params) })

      // So instead just manually put stuff in the url
      const newQuery = Object.assign(this.$route.query, params);
      const newParams = Object.keys(newQuery)
        .map((key) => {
          return `${encodeURIComponent(key)}=${encodeURIComponent(newQuery[key])}`;
        })
        .join('&');
      window.history.pushState({}, null, `${this.$route.path}?${newParams}`);
    },
  },
};
</script>

<style lang="scss" scoped>
.full-width {
  width: 100%;
}
</style>
